import { css } from '@emotion/core';
import { variables, srOnly, singleLineEllipsis, fontBase } from '@domain-group/fe-brary';
var input = variables.input,
    button = variables.button,
    colour = variables.colour,
    global = variables.global;
var hPadding = '18px';
export var defaultDropdownMaxHeight = 300;
var ellipsisPadding = '35px';
var ellipsisPaddingSmall = '20px'; // ratio between scaled font and base font size - 11px / 16px

var scaleRatio = 0.6875;
export var pxToNum = function pxToNum(pxString) {
  return Number.parseInt(pxString, 10);
};
/* eslint-disable no-bitwise */

var hexToRgb = function hexToRgb(hex) {
  var bigInt = Number.parseInt(hex.substring(1), 16);
  return [bigInt >> 16 & 255, bigInt >> 8 & 255, bigInt & 255];
};

var floatingPaddingTop = pxToNum(input.vPadding) * 1.7;
var floatingPaddingBottom = 2 * pxToNum(input.vPadding) - floatingPaddingTop;

var isBorderless = function isBorderless(appearance) {
  return appearance === 'borderless';
};

var isRounded = function isRounded(appearance) {
  return appearance === 'rounded';
};

var _ref = {
  name: "11nzcpx",
  styles: "::after{opacity:0.5;}"
};
var _ref2 = {
  name: "1baulvz",
  styles: "display:inline-block;"
};
export var domainSelect = function domainSelect(_ref11) {
  var disabled = _ref11.disabled,
      loading = _ref11.loading,
      appearance = _ref11.appearance,
      stretched = _ref11.stretched;
  return /*#__PURE__*/css("max-width:", stretched ? 'none' : '300px', ";position:relative;", (disabled || loading) && _ref, " ", isBorderless(appearance) && _ref2);
};
var smallItem = /*#__PURE__*/css("padding:", input.smallVPadding, " ", input.smallHPadding, ";padding-right:", ellipsisPaddingSmall, ";");
export var item = function item(_ref12) {
  var isSmall = _ref12.isSmall,
      isHighlighted = _ref12.isHighlighted,
      isSelected = _ref12.isSelected,
      appearance = _ref12.appearance,
      nowrap = _ref12.nowrap;
  return isBorderless(appearance) ? /*#__PURE__*/css("color:", colour.primary, ";padding:6px 12px;white-space:", nowrap ? 'nowrap' : 'normal', ";", (isHighlighted || isSelected) && /*#__PURE__*/css("color:", colour.secondary, ";background-color:transparent;"), " ", isSmall && smallItem) : /*#__PURE__*/css("padding:10px ", hPadding, ";white-space:", nowrap ? 'nowrap' : 'normal', ";", (isHighlighted || isSelected) && /*#__PURE__*/css("background-color:", colour.neutral100, ";"), " ", isSmall && smallItem);
};
var _ref3 = {
  name: "1msh118",
  styles: "display:initial;"
};
export var label = function label(_ref13) {
  var appearance = _ref13.appearance,
      floatingLabel = _ref13.floatingLabel,
      isOpen = _ref13.isOpen,
      hasLabel = _ref13.hasLabel,
      labelHidden = _ref13.labelHidden;
  return floatingLabel ? /*#__PURE__*/css(fontBase, ";", singleLineEllipsis, ";position:absolute;top:", input.vPadding, ";right:", input.hPadding, ";bottom:0;left:", input.hPadding, ";line-height:", input.lineHeight, ";transform-origin:left top;transition:transform cubic-bezier(0.25,0.8,0.25,1) 0.25s;color:", colour.inputPlaceholderText, ";pointer-events:none;", (isOpen || hasLabel) && /*#__PURE__*/css("transform:translate3d( 0,", -pxToNum(input.vPadding) * scaleRatio + 1, "px,0 ) scale(", scaleRatio, ");color:", colour.textLight, ";")) : /*#__PURE__*/css("cursor:pointer;padding-bottom:6px;display:inline-block;", labelHidden && srOnly, " ", isBorderless(appearance) && _ref3);
};
export var required = /*#__PURE__*/css("margin-left:3px;color:", variables.colour.formRequired, ";speak:none;");
var _ref4 = {
  name: "1seid7o",
  styles: "::after{transform:rotate(180deg) translateY(40%);}"
};
var _ref5 = {
  name: "wzejfw",
  styles: "::after{top:17px;right:6px;}"
};
export var selectedItemWrapper = function selectedItemWrapper(_ref14) {
  var isOpen = _ref14.isOpen,
      isSmall = _ref14.isSmall,
      appearance = _ref14.appearance;
  return /*#__PURE__*/css("position:relative;", !isBorderless(appearance) && /*#__PURE__*/css("&::after{border-width:5px 5px 0;border-color:", colour.inputText, " transparent transparent;width:0;height:0;border-style:solid;margin-top:-3.5px;transition:opacity 0.1s ease-in;opacity:0.8;content:'';pointer-events:none;position:absolute;top:22px;right:19px;}:hover::after{opacity:1;}"), " ", isOpen && _ref4, " ", isSmall && _ref5);
};
var placeholder = /*#__PURE__*/css("color:", colour.inputPlaceholderText, ";opacity:1;&:empty::after{content:'';display:block;height:", input.lineHeight, ";}");
var _ref6 = {
  name: "1i56c4p",
  styles: "&,&:focus{box-shadow:none;border-bottom:1px solid transparent;}"
};
export var selectedItem = function selectedItem(_ref15) {
  var isInvalid = _ref15.isInvalid,
      isOpen = _ref15.isOpen,
      isSmall = _ref15.isSmall,
      disabled = _ref15.disabled,
      loading = _ref15.loading,
      hasSelectedItem = _ref15.hasSelectedItem,
      floatingLabel = _ref15.floatingLabel,
      hasLabel = _ref15.hasLabel,
      appearance = _ref15.appearance;
  return /*#__PURE__*/css(singleLineEllipsis, ";padding:", input.vPadding, " ", hPadding, ";padding-right:", ellipsisPadding, ";font-size:", input.fontSize, ";line-height:", input.lineHeight, ";color:", colour.inputText, ";width:100%;transition:200ms border-color ease-in,200ms color ease-in,200ms box-shadow ease-in;border:1px solid ", colour.inputBorder, ";background-color:", colour.inputBackground, ";border-radius:3px;outline:none;text-align:left;cursor:pointer;&:focus{border-color:", colour.inputFocusBorder, ";box-shadow:0 0 0 1px ", colour.inputFocusBorder, ";max-width:100%;text-overflow:ellipsis;white-space:nowrap;}&:hover{border-color:", colour.inputHoverBorder, ";}&::placeholder{", placeholder, ";}", isSmall && smallItem, " ", !hasSelectedItem && placeholder, " ", (disabled || loading) && /*#__PURE__*/css("border-color:", colour.inputDisabledBorder, ";background-color:", colour.inputDisabledBackground, ";color:", colour.inputDisabledText, ";cursor:default;opacity:0.5;pointer-events:none;"), " ", isInvalid && !isOpen && /*#__PURE__*/css("border-color:", colour.inputErrorBorder, ";background-color:", colour.inputErrorBackground, ";color:", colour.inputErrorText, ";&:focus{border-color:", colour.inputErrorFocusBorder, ";background-color:", colour.inputErrorFocusBackground, ";color:", colour.inputErrorFocusText, ";box-shadow:0 0 0 1px ", colour.inputErrorFocusBorder, ";}"), " ", isOpen && /*#__PURE__*/css("transition:none;border-bottom:0;border-bottom-left-radius:0;border-bottom-right-radius:0;border-color:", colour.inputFocusBorder, ";box-shadow:0 0 0 1px ", colour.inputFocusBorder, ";:hover{border-color:", colour.inputFocusBorder, ";}"), " ", floatingLabel && !hasLabel && !isOpen && /*#__PURE__*/css("color:", colour.white, ";"), " ", floatingLabel && /*#__PURE__*/css("padding-top:", floatingPaddingTop, "px;padding-bottom:", floatingPaddingBottom, "px;padding-left:", input.hPadding, ";"), " ", isBorderless(appearance) && /*#__PURE__*/css("background-color:transparent;color:", colour.inputFocusBorder, ";border-color:", colour.inputFocusBorder, ";border-style:none none dashed;border-radius:0;font-size:inherit;font-weight:inherit;line-height:inherit;padding:0;transition:none;&:focus{border-style:none none dashed;box-shadow:none;}&:hover{color:", colour.linkHover, ";}", isOpen && _ref6), " ", isRounded(appearance) && /*#__PURE__*/css("display:inline-block;background-color:transparent;color:", colour.inputPlaceholder, ";border-color:", colour.inputBorder, ";border-style:solid;border-radius:22px;font-size:inherit;font-weight:inherit;line-height:inherit;padding:", input.vPadding, " ", hPadding, ";padding-right:", ellipsisPadding, ";transition:none;&:focus{border-style:solid;box-shadow:none;}&:hover{color:", colour.linkHover, ";}", isOpen && /*#__PURE__*/css("&,&:focus{border-color:", colour.inputFocusBorder, ";box-shadow:0 0 0 1px ", colour.inputFocusBorder, ";border-radius:22px;border-bottom-left-radius:0;border-bottom-right-radius:0;}")));
};
var _ref7 = {
  name: "19zs6va",
  styles: "right:0;"
};
var _ref8 = {
  name: "1trum7i",
  styles: "right:-18px;"
};
var _ref9 = {
  name: "1flgrmt",
  styles: "left:-12px;"
};
export var menuOuter = function menuOuter(_ref16) {
  var nowrap = _ref16.nowrap,
      appearance = _ref16.appearance,
      alignBody = _ref16.alignBody,
      _ref16$dropdownMaxHei = _ref16.dropdownMaxHeight,
      dropdownMaxHeight = _ref16$dropdownMaxHei === void 0 ? defaultDropdownMaxHeight : _ref16$dropdownMaxHei;
  return /*#__PURE__*/css("position:absolute;top:100%;width:", nowrap ? 'auto' : '100%', ";max-height:", dropdownMaxHeight, "px;margin-top:-2px;transition:200ms border ease-in;border:", input.borderWidth, " solid ", colour.inputBorder, ";border-top:0;border-bottom-left-radius:3px;border-bottom-right-radius:3px;border-color:", colour.inputFocusBorder, ";box-shadow:0 0 0 1px ", colour.inputFocusBorder, ";background-color:", colour.inputBackground, ";z-index:", global.layerPopout, ";-webkit-overflow-scrolling:touch;cursor:pointer;overflow:hidden;", !isBorderless(appearance) && alignBody === 'right' && _ref7, " &::before{position:absolute;top:-1px;left:0;width:100%;border-top:1px solid ", colour.white, ";content:'';}", isBorderless(appearance) && /*#__PURE__*/css("border:1px solid ", colour.primaryText, ";border-radius:", button.borderRadius, ";box-shadow:1px 1px 6px 0 rgba(", hexToRgb(colour.primaryDark).join(','), ",0.5);width:auto;padding-bottom:2px;", alignBody === 'right' ? _ref8 : _ref9, " top:115%;"), " ", isRounded(appearance) && /*#__PURE__*/css("border:", input.borderWidth, " solid ", colour.inputBorder, ";border-top:0;border-bottom-left-radius:22px;border-bottom-right-radius:22px;border-color:", colour.inputFocusBorder, ";"));
};
export var menu = function menu(_ref17) {
  var _ref17$dropdownMaxHei = _ref17.dropdownMaxHeight,
      dropdownMaxHeight = _ref17$dropdownMaxHei === void 0 ? defaultDropdownMaxHeight : _ref17$dropdownMaxHei;
  return /*#__PURE__*/css("max-height:", dropdownMaxHeight - pxToNum(input.borderWidth) * 2, "px;overflow-y:auto;");
};
export var loader = {
  name: "xke821",
  styles: "position:absolute;top:50%;right:35px;transform:translateY(-50%);"
};
export var inputField = {
  name: "1hyfx7x",
  styles: "display:none;"
};
var _ref10 = {
  name: "wubj4t",
  styles: "transform:rotate(180deg) translateY(5%);"
};
export var chevron = function chevron(_ref18) {
  var isOpen = _ref18.isOpen;
  return /*#__PURE__*/css("color:", colour.inputFocusBorder, ";position:absolute;right:-20px;top:20%;", isOpen && _ref10);
};
export var moreIcon = /*#__PURE__*/css("color:", colour.inputFocusBorder, ";position:absolute;top:20%;width:", variables.font.h5FontSize, ";height:", variables.font.h5FontSize, ";");